import posthog from 'posthog-js';

let initialized = false;

// Initialize PostHog (idempotent - safe to call multiple times)
export function initPostHog() {
  if (typeof window === 'undefined') return;
  if (initialized) return;

  const apiKey = process.env.REACT_APP_POSTHOG_KEY;

  if (!apiKey) {
    console.warn('PostHog API key not configured');
    return;
  }

  posthog.init(apiKey, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    // Respect Do Not Track
    respect_dnt: true,
    // Session recording (optional - can enable later)
    disable_session_recording: false,
  });

  initialized = true;
}

// Identify user by device ID
export function identifyUser(deviceId, properties = {}) {
  if (!posthog.__loaded) return;
  posthog.identify(deviceId, properties);
}

// Track custom events
export function trackEvent(eventName, properties = {}) {
  if (!posthog.__loaded) return;
  posthog.capture(eventName, properties);
}

// Pre-defined events for SwingSlot
export const Events = {
  // Analysis events
  ANALYSIS_STARTED: 'analysis_started',
  ANALYSIS_COMPLETED: 'analysis_completed',
  ANALYSIS_FAILED: 'analysis_failed',

  // Engagement events
  ASK_BIRDIE_OPENED: 'ask_birdie_opened',
  ASK_BIRDIE_QUESTION_SENT: 'ask_birdie_question_sent',
  FULL_REPORT_VIEWED: 'full_report_viewed',
  DRILL_VIEWED: 'drill_viewed',

  // Monetization events
  PRICING_MODAL_OPENED: 'pricing_modal_opened',
  CHECKOUT_STARTED: 'checkout_started',
  PURCHASE_COMPLETED: 'purchase_completed',

  // Auth events
  MAGIC_LINK_REQUESTED: 'magic_link_requested',
  LOGIN_COMPLETED: 'login_completed',

  // Retention events
  DASHBOARD_VIEWED: 'dashboard_viewed',
  HISTORY_VIEWED: 'history_viewed',

  // Referral events
  REFERRAL_LINK_COPIED: 'referral_link_copied',
  REFERRAL_APPLIED: 'referral_applied',
};

export default posthog;
